import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCTatiana extends NPC {
    constructor() {
        super(definitions.NPC_ID.TATIANA);

        this.collisionRadius = 26;
        this.collisionOffsetX = 10;
        this.collisionOffsetY = -28;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_tatiana_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(8, -12));
        this.animateIdle(0.35);
    }
}